// Copyright 2020 Prescryptive Health, Inc.

import { useContext } from 'react';
import { BusyContext, IBusyContext } from '../../providers/busy/busy.context';

export const useBusyContext = (): IBusyContext =>
  useContext<IBusyContext>(BusyContext);
